export default __webpack_public_path__ + "static/media/marauders-map-v5.0-gallery-07.c1f72725.jpg";